<template>
  <div class="content-editor-block video-youtube">

    <iframe v-if="isPreviewYoutube"
      :src="'https://www.youtube.com/embed/'+mValue.id"
      frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>

    <el-input v-model="mValue.id" @input="onInput" placeholder="請輸入Youtube影片連結或影片ID"><template slot="prepend">ID</template></el-input>
    <el-input v-model="mValue.width" @input="onRatioInput" placeholder="請輸入Youtube影片寬度"><template slot="prepend">寬度</template></el-input>
    <el-input v-model="mValue.height" @input="onRatioInput" placeholder="請輸入Youtube影片高度"><template slot="prepend">高度</template></el-input>

  </div>
</template>

<script>
import YoutubeLinkParser from '@/utils/YoutubeLinkParser.js'
export default {
  props: {
    value: {
      default: () => {
        return {
          id: '',
          width: 560,
          height: 315,
          ratio: 56.25
        }
      }
    }
  },
  data: () => {
    return {
      mValue: {},
      timer: null,
      isPreviewYoutube: false
    }
  },
  methods: {
    onInput () {
      this.mValue.id = YoutubeLinkParser.parse(this.mValue.id)
      if (this.mValue.id && this.mValue.id.startsWith('http')) this.$alert('網址解析失敗，請自行輸入ID')
      this.$emit('input', this.mValue)
      if (this.timer) clearTimeout(this.timer)
      if (this.mValue) this.timer = setTimeout(this.previewYoutube, 500)
      else this.previewYoutube()
    },
    onRatioInput () {
      var w = parseInt(this.mValue.width) || 0
      var h = parseInt(this.mValue.height) || 0
      if (w > 0 && h > 0) {
        this.mValue.ratio = 100 * h / w
        console.log(`ratio set to`, this.mValue.ratio)
      }
    },
    previewYoutube () {
      this.isPreviewYoutube = Boolean(this.mValue)
    }
  },
  created () {
    this.mValue = JSON.parse(JSON.stringify(this.value))
    if (this.mValue) this.previewYoutube()
  },
  watch: {
    value () {
      this.mValue = JSON.parse(JSON.stringify(this.value))
    }
  }
}
</script>
